import {
    ChakraProps,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
} from '@chakra-ui/react';
import { ReactNode, useState } from 'react';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';

type TProps = {
    label?: string;
    required?: boolean;
    type?: string;
    placeholder?: string;
    value: string | number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    helperText?: string;
    error?: boolean;
    autoComplete?: string;
    onBlur?: any;
    sx?: ChakraProps['sx'];
    sxInput?: ChakraProps['sx'];
    disabled?: boolean;
    onChangeValue?: (value: string) => void;
    readOnly?: boolean;
    rightElement?: ReactNode;
};

const InputMy = ({
    required,
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    name,
    helperText,
    error,
    autoComplete,
    onBlur,
    sx,
    disabled,
    onChangeValue,
    sxInput,
    readOnly,
    rightElement,
}: TProps) => {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(!show);

    const _type = type === 'password' && show ? 'text' : type;

    return (
        <FormControl isInvalid={error} sx={sx}>
            {label && (
                <FormLabel display="flex" fontSize="md" fontWeight="700" color="gray.900" mb="8px">
                    {label}
                    {required && <Text color="red.500">&nbsp;*</Text>}
                </FormLabel>
            )}
            <InputGroup size="md">
                <Input
                    readOnly={readOnly}
                    sx={sxInput}
                    onBlur={onBlur}
                    name={name}
                    value={value}
                    onChange={onChangeValue ? e => onChangeValue(e.target.value) : onChange}
                    isRequired={required}
                    variant="auth"
                    fontSize="md"
                    ms={{ base: '0px', md: '0px' }}
                    type={_type}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    fontWeight="500"
                    size="lg"
                    disabled={disabled}
                />
                {type === 'password' && (
                    <InputRightElement display="flex" alignItems="center" mt="4px" userSelect="none">
                        <Icon
                            color="gray.900"
                            _hover={{ cursor: 'pointer' }}
                            as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                            onClick={handleShow}
                        />
                    </InputRightElement>
                )}
                {rightElement && (
                    <InputRightElement display="flex" alignItems="center" height="100%" userSelect="none" mr="4px">
                        {rightElement}
                    </InputRightElement>
                )}
            </InputGroup>
            <FormErrorMessage
                sx={{
                    fontSize: '14px',
                    fontWeight: '500',
                }}
            >
                {helperText}
            </FormErrorMessage>
        </FormControl>
    );
};

export default InputMy;
